import RoutesMap from "../../route_control/RouteControl"
import UserLogin from "../../pages/user/user_login/UserLogin"
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

export const AuthRouteImport = {
    UserLogin,
    RoutesMap,
    useNavigate,
    Swal
}